import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

    clients: any = [
        { name: 'Apple', id: 1, activeAds: 11, logo: 'apple.png' },
        { name: 'Google', id: 2, activeAds: 21, logo: 'google.png' },
        { name: 'Coca-Cola', id: 3, activeAds: 22, logo: 'coca-cola.png' },
        { name: 'Microsoft', id: 4, activeAds: 65, logo: 'microsoft.png' },
        { name: 'Toyota', id: 5, activeAds: 43, logo: 'toyota.png' },
        { name: 'IBM', id: 6, activeAds: 24, logo: 'ibm.png' },
        { name: 'Samsung', id: 7, activeAds: 65, logo: 'samsung.png' },
        { name: 'Amazon', id: 8, activeAds: 15, logo: 'amazon.png' },
    ];

    constructor() {

    }
    ngOnInit() {

    }
    ngAfterViewInit() {

        mLayout.initHeader();

    }

}


// WEBPACK FOOTER //
// /home/node/src/app/theme/layouts/header-nav/header-nav.component.ts